<template>
  <div id="app">
    <Header v-if="showHeader"/>
    <img v-if="showGlasses" alt="Glasses logo" src="./assets/glasses.svg">
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',
  data() {
    return {
      showGlasses: true,
      showHeader: true,
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    //Just in case our watch doesn't fire and we've hit the app directly
    let meta = this.$route.meta;
    this.showGlassesFunction(meta.showGlasses);
    this.showHeaderFunction(meta.showHeader);
  },
  watch: {
    '$route'() {
      let meta = this.$route.meta;
      this.showGlassesFunction(meta.showGlasses);
      this.showHeaderFunction(meta.showHeader);
    }
  },
  methods: {
    showGlassesFunction(val) {
      if (val != undefined) {
        this.showGlasses = val;
      } else {
        this.showGlasses = true;
      }
    },
    showHeaderFunction(val) {
      if (val != undefined) {
        this.showHeader = val;
      } else {
        this.showHeader = true;
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:ital,wght@1,300&display=swap');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
img {
  align-self: center;
  height: 8em;
  width: 8em;
}
a {
    float: inherit; 
    color: #2061b7;
    text-decoration: none;
    padding-bottom: none;
    font-size: 18px; 
    line-height: 1em;
  }

  a:hover {
    color: black;
    border-bottom: 2px solid black;
  }

  p {
    color: black;
  }
</style>
